import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { Icon, Input, Checkbox, Label, Popup } from 'semantic-ui-react';
import classNames from 'classnames';
import _ from 'lodash';

import { RecipeCategoryEnum } from 'Common/Constants/Enumeration/RecipeCategoryEnum';
import { NutritionalHoverConnected } from 'Common/Components/NutritionalHover/NutritionalHover';

import { getMealContributionMessage } from '../utilities';

class DailyViewCategoryItem extends Component {
  static propTypes = {
    item: PropTypes.object,
    isReadOnly: PropTypes.bool,
    onItemClick: PropTypes.func,
    disableHover: PropTypes.bool,
    onQtyOfPortionChange: PropTypes.func,
    onProjectedServingsChange: PropTypes.func,
    onProjectedServingsBlur: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onItemPercentageChange: PropTypes.func,
    onItemPercentageBlur: PropTypes.func,
    selected: PropTypes.bool,
    onHideClick: PropTypes.func,
    itemPercentage: PropTypes.number,
    onDoubleClick: PropTypes.func,
    onToggleAlacarte: PropTypes.func,
    isItemInactive: PropTypes.func,
    openRecipe: PropTypes.func,
    lassoMode: PropTypes.bool,
  };

  static qtyOfPortionPattern = /^(\d{1,2}[.]?|\d{1,2}[.]\d{1,4})?$/;

  draggableRef = null;

  onItemClick = (id) => (e) => {
    const { onItemClick } = this.props;

    if (!e.defaultPrevented) {
      if (this.draggableRef) {
        // Will blur any focused inputs when clicking the row
        this.draggableRef.focus();
      }
    }

    onItemClick(id)(e);
  };

  onInputClick = (e) => {
    // Prevent selecting item when input is focused
    e.stopPropagation();
  };

  onKeyDown = (e) => {
    const { key } = e;

    if (key === 'Delete' || key === 'Backspace') {
      // Prevent deleting the item if input is focused
      e.stopPropagation();
    }
  };

  onAlacarteCheckboxClick = (item) => (e) => {
    const { onToggleAlacarte, recipeCountByDayMap } = this.props;
    this.onInputClick(e);

    const recipeCount = _.get(
      recipeCountByDayMap,
      [item.DayNumber, item.RecipeId],
      0
    );

    if (recipeCount < 2) {
      onToggleAlacarte(item.draggableId)();
    }
  };

  Item = (props) => {
    const {
      isChild,
      isReadOnly,
      disableHover,
      onQtyOfPortionChange,
      onQtyOfPortionBlur,
      onProjectedServingsChange,
      onProjectedServingsBlur,
      onDeleteClick,
      selected,
      onHideClick,
      onDoubleClick,
      item,
      combineTarget,
      onClick,
      onProjectedServingsPercentageBlur,
      onProjectedServingsPercentageChange,
      onRemoveChild,
      parentId,
      recipeCountByDayMap,
      isItemInactive,
      openRecipe,
      copied,
    } = props;

    const recipeCount = _.get(
      recipeCountByDayMap,
      [item.DayNumber, item.RecipeId],
      0
    );

    return (
      <div
        onClick={onClick}
        data-draggable-id={item.draggableId}
        className={classNames('daily-menu-row ', {
          child: isChild,
          selected,
          copied,
          entree: item.RecipeCategoryId === RecipeCategoryEnum.Entree,
          combineTarget,
        })}
      >
        <div className="daily-category-column">
          {isChild && (
            <Icon
              onClick={onRemoveChild(item.draggableId, parentId)}
              className="child-remove-icon"
              name="minus"
            />
          )}
          <NutritionalHoverConnected
            recipeId={item.RecipeId}
            showDisclaimer={false}
            showServingCost={true}
            disableHover={disableHover}
            openDelay={1000}
            openRecipe={openRecipe}
          >
            <div
              className={classNames('daily-menu-text daily-menu-item-name', {
                inactive: isItemInactive(item.RecipeInactive),
              })}
              onDoubleClick={() => onDoubleClick(item)}
            >
              {item.Name}
            </div>
          </NutritionalHoverConnected>
        </div>
        <div
          className={classNames(
            'daily-menu-column meal-contribution daily-menu-text',
            {
              child: isChild,
            }
          )}
        >
          {getMealContributionMessage(item)}
        </div>
        <div
          className={classNames('daily-menu-column serving-size', {
            child: isChild,
          })}
        >
          <Input
            type="text"
            className="menu-input"
            maxLength={7}
            fluid
            value={item.QtyOfPortion}
            onChange={onQtyOfPortionChange(item.draggableId)}
            onBlur={onQtyOfPortionBlur(item.draggableId)}
            disabled={isReadOnly}
            onClick={this.onInputClick}
            onKeyDown={this.onKeyDown}
            label={
              <Popup
                trigger={
                  <Label basic className="serving-size-label">
                    <span>{item.RecipeMeasure}</span>
                  </Label>
                }
                content={item.RecipeMeasure}
                className="serving-size-label"
              />
            }
            labelPosition="right"
          />
        </div>
        <div
          className={classNames('daily-menu-column planned-servings', {
            child: isChild,
          })}
        >
          <Input
            type="text"
            maxLength={6}
            fluid
            value={item.ProjectedServings}
            onChange={onProjectedServingsChange(item.draggableId)}
            onBlur={onProjectedServingsBlur(item.draggableId)}
            disabled={isReadOnly}
            onClick={this.onInputClick}
            onKeyDown={this.onKeyDown}
            className="menu-input"
          />
        </div>
        <div
          className={classNames('daily-menu-column servings-percentage', {
            child: isChild,
          })}
        >
          <Input
            type="text"
            value={item.ServingsPercentage}
            onChange={onProjectedServingsPercentageChange(item.draggableId)}
            onBlur={onProjectedServingsPercentageBlur(item.draggableId)}
            disabled={isReadOnly}
            onClick={this.onInputClick}
            onKeyDown={this.onKeyDown}
            maxLength={6}
            icon="percent"
            fluid
            className="menu-input"
          />
        </div>
        <div className="daily-menu-column alacarte">
          {!isChild && (
            <div className="daily-menu-alacarte-checkbox">
              <Checkbox
                onChange={this.onAlacarteCheckboxClick(item)}
                checked={item.Alacarte}
                disabled={isReadOnly || recipeCount > 1}
              />
            </div>
          )}
        </div>
        {!isReadOnly && (
          <div className="daily-menu-right-icons">
            <Icon
              className={classNames({
                eye: item.DisplayOnCalendar,
                'fa-eye-slash': !item.DisplayOnCalendar,
              })}
              onClick={onHideClick(item.draggableId, item.DisplayOnCalendar)}
            />
            <Icon className="trash" onClick={onDeleteClick(item)} />
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      item,
      isReadOnly,
      isItemSelected,
      isItemCopied,
      lassoMode,
    } = this.props;

    const { Item } = this;

    return (
      <Draggable
        index={item.OrderNum}
        draggableId={item.draggableId}
        isDragDisabled={isReadOnly || lassoMode}
      >
        {(provided, snapshot) => {
          return (
            <div
              ref={(ref) => {
                this.draggableRef = ref;
                provided.innerRef(ref);
              }}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <Item
                {...this.props}
                selected={isItemSelected(item.draggableId)}
                copied={isItemCopied(item.draggableId)}
                item={item}
                combineTarget={Boolean(snapshot.combineTargetFor)}
                onClick={this.onItemClick(item.draggableId)}
              />
              {item.Children.map((child, index) => (
                <Item
                  key={index}
                  {...this.props}
                  selected={isItemSelected(child.draggableId)}
                  item={child}
                  onClick={this.onItemClick(child.draggableId)}
                  isChild
                  parentId={item.draggableId}
                />
              ))}
            </div>
          );
        }}
      </Draggable>
    );
  }
}

export { DailyViewCategoryItem };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/DailyViewCategoryItem.js